import { render, staticRenderFns } from "./top.vue?vue&type=template&id=1469550c&scoped=true"
var script = {}
import style0 from "./top.vue?vue&type=style&index=0&id=1469550c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1469550c",
  null
  
)

export default component.exports